import { getCurrentEnv } from '@sfly/uig-current-environment-util';
import axios from 'axios';
import { DC_SERVICE_API_KEYS } from '../util/AppConstant';
import { logger } from '../util/AppUtil';
import { getCurrentEnvironmentConfig } from '../../src/util/AppUtil';

function handleDynamicContentError(error, contentSpaceName) {
    const details = {
        error: error.message,
        contentSpaceName
    }
    logger.error({
        appContext: {
            msg: `Failed to get the dynamic content`,
            details
        }
    });
    return {};
}

export function parseContent(response, contentSpaceName) {
    let dynamicContent = {};
    if (response && response.dynamicContents) {
        response.dynamicContents.forEach((dc) => {
            let content = dc.dynamicContent ? dc.dynamicContent : '';
            content = content.replace('<!-- HTML Content Wrapper -->', '');
            content = content.replace('<!-- /HTML Content Wrapper -->', '');
            content = content.trim();
            try {
                dynamicContent = JSON.parse(content);
            }
            catch (error) {
                // Log an error if the string does not start with '<' (HTML)
                if (content.length === 0 || content[0] !== '<') {
                    logger.error({
                        appContext: {
                            msg: `Failed to parse the dynamic content`,
                            error: error.message,
                            contentSpaceName
                        }
                    });
                }
                dynamicContent = {
                    contentImage: content
                }
            }
        });
    } else if (response && response.imageURL) {
        dynamicContent = {
            "contentImage": `<picture> <img src=${response.imageURL.replace('https:', '')} alt="${response.altText}" style = 'width:100%'> </picture>`
        }
    }
    return dynamicContent;
}

export function getDynamicContent(contentSpaceName, newDynamicContent, brand, isRegularPage) {
    let currentEnv;
    if (getCurrentEnv() === 'production') {
        currentEnv = '';
    } else {
        currentEnv = getCurrentEnv() + '.';
    };
    const batchDynamicContentUrl = newDynamicContent && isRegularPage ? `https://store.${currentEnv}shutterfly.com/site/sfly-api/plp?vanity=${contentSpaceName}&brand=${brand.toUpperCase()}`  : `${getCurrentEnvironmentConfig().apigeeBaseUrl}/v1/services-dynamic-content/v1/dynamic-content/batch?contentSpaces=${contentSpaceName}`;
    const config = newDynamicContent ? {
        headers: {
            'Accept': 'application/json',
        },
    }:{
        headers: {
            'SFLY-Apikey':
                getCurrentEnv() === 'production'
                    ? DC_SERVICE_API_KEYS.PROD
                    : DC_SERVICE_API_KEYS.NON_PROD,
            'Accept': 'application/json'
        },
    };
    return axios.get(batchDynamicContentUrl, config)
        .then(response => parseContent(response.data, contentSpaceName))
        .catch(error => handleDynamicContentError(error, contentSpaceName));
}